import { Fragment as _Fragment, createElementVNode as _createElementVNode, mergeProps as _mergeProps } from "vue";
// Composables
import { makeComponentProps } from "../../composables/component.js";
import { useResizeObserver } from "../../composables/resizeObserver.js"; // Utilities
import { shallowRef, watch } from 'vue';
import { genericComponent, propsFactory, templateRef, useRender } from "../../util/index.js"; // Types
export const makeVVirtualScrollItemProps = propsFactory({
  renderless: Boolean,
  ...makeComponentProps()
}, 'VVirtualScrollItem');
export const VVirtualScrollItem = genericComponent()({
  name: 'VVirtualScrollItem',
  inheritAttrs: false,
  props: makeVVirtualScrollItemProps(),
  emits: {
    'update:height': height => true
  },
  setup(props, {
    attrs,
    emit,
    slots
  }) {
    const el = templateRef();
    const itemHeight = shallowRef();
    // keep borderBoxSize to ignore CSS transforms (e.g. VDialogTransition scale-in)
    useResizeObserver(() => el.el, entries => {
      itemHeight.value = entries[0].borderBoxSize?.[0]?.blockSize ?? entries[0].target.offsetHeight;
    }, {
      box: 'border-box'
    });
    watch(itemHeight, height => {
      if (height != null) emit('update:height', height);
    });
    useRender(() => props.renderless ? _createElementVNode(_Fragment, null, [slots.default?.({
      itemRef: el
    })]) : _createElementVNode("div", _mergeProps({
      "ref": el,
      "class": ['v-virtual-scroll__item', props.class],
      "style": props.style
    }, attrs), [slots.default?.()]));
  }
});
//# sourceMappingURL=VVirtualScrollItem.js.map